import { render, staticRenderFns } from "./TypographyDisplay.vue?vue&type=template&id=4a5c6716&"
import script from "./TypographyDisplay.vue?vue&type=script&lang=js&"
export * from "./TypographyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports